<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br/>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>ลำดับ</th>
                        <th>เลขที่ใบกำกับ</th>
                        <th>วันที่</th>
                        <th>ครบกำหนด</th>
                        <th>จำนวนเงิน</th>
                        <th>ยอดคงเหลือ</th>
                        <th>ยอดชำระ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data,index) in details">
                        <td>{{++index}}</td>
                        <td>
                            <template v-if="data.tax_invoice">
                                {{data.tax_invoice.tax_invoice}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_invoice">
                                {{data.tax_invoice.date | moment("DD/MM/YYYY")}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_invoice && data.tax_invoice.invoice">
                                {{data.tax_invoice.invoice.due_date | moment("DD/MM/YYYY")}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_invoice && data.tax_invoice.invoice">
                                {{data.tax_invoice.invoice.total | currency}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_invoice && data.tax_invoice.invoice">
                                {{parseFloat(data.tax_invoice.invoice.total) - parseFloat(data.tax_invoice.invoice.remaining_payoff) | currency}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_invoice && data.tax_invoice.invoice">
                                {{data.tax_invoice.invoice.remaining_payoff | currency}}
                            </template>
                            <template v-else>-</template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--<pre class="alert-primary">{{details}}</pre>-->
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import { domain } from "../../../util/Constants";
    import moment from "moment";
    export default {
        name: "billing-r-e-form",
        created(){

        },
        data(){
            return {
                items: [
                    {
                        text: "รายการใบเสร็จ",
                        to: { name: "billing-RE-list" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        computed:{
            ...mapState({
                details :state=>{
                    return state.BillingRE.billing_details
                }
            })
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped>
thead{
    background-color: white;
    color: black;
}
tbody{
    background-color: white;
    color: black;
}
</style>